
import System from 'src/helper/system';
import { Tooltip } from '../Global/Tooltip';
import React from 'react';

const SpecialOffer = (props) => {
    const { single_product, single_product_inventory } = props;
    const pkg = single_product.PackagingTypeCode;

    const showSpecialOffer = () => {
        let stock = single_product_inventory.inventoryQty;
        return (single_product.isAvnetDistributor && stock > 0) && (stock < single_product.QtyMin);
    }

    return (
        <div>
            {showSpecialOffer() &&
                <Tooltip
                    position={'bottom center'}
                    opener={() => (
                        <div className='speqtyoffer' style={{ cursor: 'pointer' }}>
                            <span>Special Qty Offer</span>
                            <div>
                                Up to Qty: {single_product_inventory.inventoryQty}<br />
                                In Min: {single_product_inventory.inventoryQty < single_product.QtyMult ? 1 : single_product.QtyMult} Mult: {System.isSpecialOfferPkg(pkg) || (single_product_inventory.inventoryQty < single_product.QtyMult) ? 1 : single_product.QtyMult}
                            </div>
                        </div>
                    )}
                    content={() => (
                        <div className='text-start'>
                            Special Min/Mult on this item are only valid on available stock.<br />
                            Standard Min/Mult will apply on backorders.
                        </div>
                    )}
                />
            }
        </div>
    );
}

export default SpecialOffer;